import { BankOutlined, NumberOutlined, PercentageOutlined, TagOutlined, TrademarkOutlined } from "@ant-design/icons";
import MasterCrudScreen from "./Mastercrudscreen";
import { MASTERS } from "./Masterapi";
import { INDIGO, TEAL } from "./Mastertheme";

const config = {
    master: MASTERS.brand,
    title: "Brand Master",
    singular: "Brand",
    plural: "Brands",
    subtitle: "Manage brand names, codes and discount",
    icon: <TrademarkOutlined />,
    from: TEAL,
    to: INDIGO,
    fields: [
        { name: "compName", label: "Brand Name", placeholder: "e.g. RAYMOND", required: true, icon: <BankOutlined /> },
        { name: "compCode", label: "Brand Code", placeholder: "e.g. RAY", icon: <NumberOutlined /> },
        { name: "disper", label: "Discount %", placeholder: "0", type: "number", icon: <PercentageOutlined /> },
        { name: "btype", label: "Brand Type", placeholder: "e.g. LOCAL", icon: <TagOutlined /> },
    ],
};

export default function BrandMaster() {
    return <MasterCrudScreen config={config} />;
}